import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

@Module({ dynamic: true, store, name: "base" })
export class BaseVuexModule extends VuexModule {
  snackBarPayload: SnackBarPayload = {
    show: false,
    message: "",
    color: "success",
    timeout: -1,
  };
  isLoading: boolean = false;

  @Mutation
  setSnackBarPayload(snackBarPayload: SnackBarPayload) {
    this.snackBarPayload = snackBarPayload;
  }

  @Mutation
  setLoadingStatus(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  @Action
  public async showMessage({
    message,
    color = "success",
    timeout = 6000,
    account,
  }: SnackBarPayload) {
    this.setSnackBarPayload({
      message,
      color,
      timeout,
      show: true,
      account,
    });
  }
}

export const BaseModule = getModule(BaseVuexModule);
